import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { MAP_COLORS } from '../util/MapUtil.jsx';

const MapLegend = ({ title, values, visibleColorsHashmap }) => {
	const [collapsed, setCollapsed] = useState(false);
	const swatches = values.map((value, index) => {
		if (!(index in visibleColorsHashmap)) {
			return false;
		}
		const colorStyle = {
			backgroundColor: MAP_COLORS[index]
		};
		return (
			<div key={index} className="swatch">
				<div className="color" style={colorStyle}></div>
				<div className="name">{value}</div>
			</div>
		);
	});
	return (
		<div className={classnames('mapLegend', { 'mapLegend--collapsed': collapsed })}>
			<button
				type="button"
				className="mapLegend-toggle"
				onClick={() => { setCollapsed(prev => !prev); }}
				aria-expanded={!collapsed}>
				<span className="mapLegend-title">{title || 'Map Legend'}</span>
				<span
					className={classnames(
						'glyphicon',
						collapsed ? 'glyphicon-chevron-up' : 'glyphicon-chevron-down'
					)}
					aria-hidden="true">
				</span>
			</button>
			{collapsed
				? null
				: <div className="mapLegend-body">{swatches}</div>}
		</div>
	);
};

MapLegend.propTypes = {
	title: PropTypes.string,
	values: PropTypes.arrayOf(PropTypes.string),
	visibleColorsHashmap: PropTypes.objectOf(PropTypes.bool)
};

export default MapLegend;
